   $(document).ready(function () {

// Expose the in-place cart refresh so other scripts (trade-in enforce) can update smoothly without a full reload.
window.cartSectionReload = function () { successreload(); };

$(document).on('change', '.quantity-selector__input', function(event) {
  $tvar = $(this);
 updateCartQuantity($tvar,$(this).attr('v-id'), $(this).val(),$(this).attr('maxallowed'));
});

$(document).on('click', '.iaddon:not(.checked)', function(event) {
  // Adds the add-on and refreshes the cart in place (no full reload) for a smooth, instant update.
  addCartitem($(this).attr('v-id'),$(this).attr('venmeta'));
});
$(document).on('click', '.boxedbtn', function(event) {
  addCartitem($(this).attr('v-id'));

});
$(document).on('click', '.iaddon.checked', function(event) {
  // Removes the add-on and refreshes the cart in place (no full reload) for a smooth, instant update.
  // If this was Recycle on a trade-in product with the discount applied, main-cart.liquid's
  // reconciliation script (triggered by the cart:refresh event below) cancels the discount.
  removeitem($(this).attr('key'),true);
});
     
$(document).on('click', '.iremove', function(event) {   
  $addons = $(this).parents('.cart__item').find('.iaddon.checked');
  if($addons.length > 0){
  removeitem($(this).attr('key'),false);
  }else{
  removeitem($(this).attr('key'),true);
  }
  $addons.each(function(index){    
    if (index === $addons.length - 1) {
      removeitem($(this).attr('key'),true);
    }else{
      removeitem($(this).attr('key'),false);
    }
  });
});

function removeitem(key,check) {
  $('.page-content').css('filter','blur(4px)');
  $.ajax({
                    url: '/cart/change?id='+key+'&quantity=0',
                    method: "POST",

                    success: function(cart) {
                      if(check){
        successreload();
                      }
                    },
        error: function (error) {
          $('.carterror').css('transform','translateY(0)');
      setTimeout(function() {
          $('.carterror').css('transform','translateY(100%)');
  $('.page-content').css('filter','blur(0)');
  }, 2000);
          console.error('Error updating cart:', error);}
                });
}
function updateCartQuantity($tvar,variantId, quantityChange,maxallowed) {
  if(!maxallowed){
    maxallowed = 50;
  }
                if(quantityChange <= maxallowed ){
$('.page-content').css('filter','blur(4px)');
      $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: {
            updates: {
                [variantId]: quantityChange
            }
        },
        dataType: 'json',
        success: function (response) {
          successreload();
        },
        error: function (error) {
          $('.carterror').text('There is an error in updating your cart');
          $('.carterror').css('transform','translateY(0)');
          successreload();
      setTimeout(function() {
          $('.carterror').css('transform','translateY(100%)');
  $('.page-content').css('filter','blur(0)');
  }, 2000);
          console.error('Error updating cart:', error);}
    });
                }else{
                  $tvar.prop('selectedIndex', $tvar.attr('previousIndex'));

      $('.carterror').text('Maximum Allowed quantity is ' + maxallowed);
                   $('.carterror').css('transform','translateY(0)');
      setTimeout(function() {
          $('.carterror').css('transform','translateY(100%)');
  $('.page-content').css('filter','blur(0)');
  }, 2000);
                }
                
  
  
        
      }




     function addCartitem(variantId, properties){
  $('.page-content').css('filter','blur(4px)');
       items = [];
       if(properties){
         items.push({ id: variantId, quantity: 1, properties:{'Product':properties } });
       }else{
         items.push({ id: variantId, quantity: 1});
       }
   
       fetch('/cart/add.js', {
       method: 'POST',
       body: JSON.stringify({ items: items }),
       headers: { 'Content-type': 'application/json' },
       credentials: 'include' 
     })
     .then(response => {
  		successreload();
     })
     .catch((error) => {
       $('.carterror').text('There is an error in updating your cart');
          $('.carterror').css('transform','translateY(0)');
      setTimeout(function() {
          $('.carterror').css('transform','translateY(100%)');
  $('.page-content').css('filter','blur(0)');
  }, 2000);
       console.error('Error:', error);
    });
     }

     function successreload(){
       // Full page reload on every cart update instead of the in-place AJAX section swap.
       window.location.reload();
     }



     
   });